import React from 'react';

import { Button, PrimaryButton, Icon, useTranslation } from '@testsigma/atoms';

import { SalesforceLoginMethod } from '@modules/salesforce/models';
import { bool } from 'yup';

interface OAuthFormActionsProps {
  loginMethod: SalesforceLoginMethod;
  isConnecting: boolean;
  isValid: boolean;
  isTestConnecting: boolean;
  handleLogin: () => void;
  handleUpdate?: () => void;
  handleClose: (event: React.SyntheticEvent) => void;
}

export const OAuthFormActions: React.FC<OAuthFormActionsProps> = (
  props: OAuthFormActionsProps,
) => {
  const { t } = useTranslation();

  const {
    loginMethod,
    isConnecting,
    isValid,
    isTestConnecting,
    handleLogin,
    handleUpdate,
    handleClose,
  } = props;

  if (loginMethod !== SalesforceLoginMethod.OAUTH) {
    return null;
  }

  return (
    <div className='px-4 py-3 text-right'>
      <Button type='secondary' isDisabled={isConnecting || isTestConnecting} onClick={handleClose}>
        {t('common.cancel')}
      </Button>

      {handleUpdate ? (
        <PrimaryButton
          className='ml-4'
          isDisabled={!isValid || isConnecting|| isTestConnecting}
          onClick={handleUpdate}>
          {t('common.save.changes')}
        </PrimaryButton>
      ) : (
        <PrimaryButton
          className='ml-4'
          isDisabled={!isValid || isConnecting || isTestConnecting}
          onClick={handleLogin}>
          <>
            {isConnecting ? (
              <div className='flex gap-x-1.5 items-center'>
                <Icon className='text-base flex animate-spin' name='loader' />
                {t('connecting.button.label')}
              </div>
            ) : (
              'Authorise & Connect'
            )}
          </>
        </PrimaryButton>
      )}
    </div>
  );
};
